module.exports = __webpack_public_path__ + "static/media/03.75bb58bb.jpg";